import moment from "moment";

export class Location {
    LocCode;
    LocDesc;
    ParentLoc;
    Addr;
    Country;
    District;
    Area;
    NFCTag;
    AddBy;
    constructor() {
        this.LocCode = "";
        this.LocDesc = "";
        this.ParentLoc = "";
        this.Addr = "";
        this.Country = "";
        this.District = "";
        this.Area = "";
        this.NFCTag = "";
        this.AddBy = "";
    }
}



// WEBPACK FOOTER //
// ./src/model/Location.js